import { useFeatures, useCallback } from 'sb-hooks'
import actions from 'redux/actions'
import { constants, mixpanel } from 'common/helpers'
import { useMemo } from 'react'


const getRefundTimeTypes = (isBillingDay1stEnabled) => ({
  'NEW_SUBSCRIBER': 'before 12 hours',
  'RECURRENT_DAY': isBillingDay1stEnabled ? 'on the 1st' : 'on the 5th',
})

/**
 * Use Refund functional
 * @param modalName {String}
 * @param type {String}
 * @param transactionType {String}
 * @returns {{isBillingDay1stEnabled: *, chooseRefund: *, chooseReceive: *, close: *}}
 */
const useRefund = (modalName, type, transactionType = 'UNSUBSCRIBE') => {
  const { [constants.features.billingDay1stDayOfTheMonth]: isBillingDay1stEnabled } = useFeatures()

  const close = useCallback(() => {
    actions.models.modals.close(modalName)
  }, [ modalName ])

  const analyticsEvent = useMemo(() => {
    let eventName = constants.analyticsEvents.unsubscribe

    if (transactionType !== 'UNSUBSCRIBE') {
      eventName = `${transactionType} choose option`
    }

    return eventName
  }, [ transactionType ])

  const chooseRefund = useCallback(() => {
    mixpanel.track(analyticsEvent, {
      'type time': getRefundTimeTypes(isBillingDay1stEnabled)[type],
      'type cancel': 'refund',
      'type transaction': transactionType,
    })

    close()
    actions.models.ui.showRequestLoader()
    return actions.models.subscription.refund({
      transactionType,
      decision: 'REFUND',
    })
      .finally(() => actions.models.ui.hideRequestLoader())
  }, [ type, transactionType, isBillingDay1stEnabled, close, analyticsEvent ])

  const chooseReceive = useCallback(() => {
    mixpanel.track(analyticsEvent, {
      'type time': getRefundTimeTypes(isBillingDay1stEnabled)[type],
      'type cancel': 'keep',
      'type transaction': transactionType,
    })

    close()
    actions.models.ui.showRequestLoader()
    return actions.models.subscription.refund({
      transactionType,
      decision: 'RECEIVE',
    })
      .finally(() => actions.models.ui.hideRequestLoader())
  }, [ type, transactionType, isBillingDay1stEnabled, close, analyticsEvent ])

  return {
    isBillingDay1stEnabled,
    chooseRefund,
    chooseReceive,
    close,
  }
}


export default useRefund
